import { lazy } from 'react';

export default lazy(() => import('./client_add_form'));
